import Vue from 'vue';

// When the request succeeds
const success = (response, context) => {
  toastr.success(context.$t('booking.detail.contract_successfully_updated'));
  context.loading = false;
  context.smallLoading = false;
  context.isValidated = false;
  context.getContractByBookingId(context.permalink, false);
};

// When the request fails
const failed = (error, context) => {
  context.loading = false;
  if (error.response && error.response.data && error.response.data.msg) {
    Object.values(error.response.data.msg).forEach(value => {
      toastr.error(value[0]);
    });
  }
};

export default (contract, context) => {
  return Vue.$http.post('bookings/update/contract', contract)
    .then((response) => {
      if (response && response.status === 200) {
        success(response, context);
      }
    })
    .catch((error) => {
      failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/booking/updateContract.js